import { Component, Input } from '@angular/core';

@Component({
  selector: 'merchant-products-sidebar',
  templateUrl: './merchant-products-sidebar.component.html',
  styleUrl: './merchant-products-sidebar.component.scss'
})
export class MerchantProductsSidebarComponent {
  @Input() showViewProductSidebar: boolean = false;
  closeSidebar(){

  }
}
